import React from 'react';
import _ from 'lodash';
import { Query, Mutation } from 'react-apollo';

import {
  queryMockExamAvailableExams,
  queryMockExamStudentExamCards,
} from '../../GraphQL/query/StudentExam.query';
import { AddMockExamStudentExams } from '../../GraphQL/mutation/StudentExam.mutation';
import Loading from '../../Components/Loading';

import AddStudentExamWithCloseCallback from './AddStudentExamWithCloseCallback';

const AddStudentExam = ({ locationCode, roundCode, onClose }) => (
  <Query query={queryMockExamAvailableExams} variables={{ roundCode, locationCode }}>
    {({ loading, error, data }) => {
      if (loading)
        return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
      if (error) return <div>{JSON.stringify(error)}</div>;
      const exams = data && data.mockExamAvailableExams ? data.mockExamAvailableExams.exams : [];

      return (
        <Mutation
          mutation={AddMockExamStudentExams}
          refetchQueries={[{ query: queryMockExamStudentExamCards, variables: { roundCode } }]}
        >
          {(addStudentExams, { data }) => {
            return (
              <AddStudentExamWithCloseCallback
                data={data}
                onClose={onClose}
                displayError={_.get(data, 'addMockExamStudentExams.success') === false}
                exams={exams}
                roundCode={roundCode}
                mutation={addStudentExams}
              />
            );
          }}
        </Mutation>
      );
    }}
  </Query>
);

export default AddStudentExam;
